/**
 * Account-activation feature strings.
 *
 * Namespace: accountActivation
 */
export const accountActivation = {
  // Page
  page: {
    title: "Jelszó beállítása",
    subtitle: "Hozza létre a fiókjához tartozó első jelszavát",
    checking: "Ellenőrzés...",
  },

  // Form fields
  form: {
    passwordLabel: "Új jelszó",
    passwordPlaceholder: "••••••••",
    passwordHelperText: "Legalább 8 karakter",
    confirmPasswordLabel: "Jelszó megerősítése",
    confirmPasswordPlaceholder: "••••••••",
    submitButton: "Jelszó beállítása",
  },

  // Errors
  errors: {
    invalidLink: "Az aktivációs link érvénytelen vagy lejárt.",
    recaptchaFailed: "reCAPTCHA ellenőrzés sikertelen. Kérjük, próbálja újra.",
  },
} as const;
